import React from 'react';
import { connect } from 'react-redux';


class Unauthorised extends React.Component {
  constructor(props) {
    super(props);

    // reset login status
  }
  render() {
    // TODO: we might have a log out page to pop up but as we haven't reviwed it, till now we are going to reroute logout page to login
    return <h1>Work in Progress. Will be here soon...</h1>;
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}

const unauthorised = connect(mapStateToProps)(Unauthorised);

export default (unauthorised);
